import React from "react";

import BasicBadge from "./BasicBadge";

export const ACTIVATION_BADGE = {
  ACTIVE: {
    variant: "success",
    svg: "/General/Visible.svg",
  },
  INACTIVE: {
    variant: "danger",
    svg: "/General/Visible.svg",
  },
};

//activity status
export const IS_ACTIVE_STATUSES = [
  { id: 1, label: "ACTIVE" },
  { id: 0, label: "INACTIVE" },
];
const UserActivationBadge = ({ activationStatus, size = "md" }) => {
  if (!activationStatus) return "";

  return (
    <>
      {activationStatus && (
        <BasicBadge
          tooltipMessage={activationStatus}
          size={size}
          svg={ACTIVATION_BADGE[activationStatus]?.svg || ""}
          variant={ACTIVATION_BADGE[activationStatus]?.variant || ""}
        />
      )}
    </>
  );
};
export default UserActivationBadge;
